<template>
  <div class="oai-FailedStep">
    <div class="oai-FailedStep_Header">
      <div class="oai-FailedStep_LogoContainer">
        <AppLogo type="short" width="64" height="64" />
      </div>

      <div class="oai-FailedStep_Title">
        {{ $t('onboarding.ai.failed.title') }}
      </div>

      <div class="oai-FailedStep_Subtitle">
        {{ $t('onboarding.ai.failed.subtitle') }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'

import { ONBOARDING_AI_FAILED_REDIRECT_DELAY_MS } from '@/utils/onboarding-ai/loading-step-config'

import AppLogo from '@/components/AppLogo'

defineOptions({
  name: 'OnboardingAiFailedStep'
})

const emit = defineEmits({
  complete: null
})

let redirectTimeoutId = null

onMounted(() => {
  redirectTimeoutId = setTimeout(() => {
    emit('complete')
  }, ONBOARDING_AI_FAILED_REDIRECT_DELAY_MS)
})

onUnmounted(() => {
  if (redirectTimeoutId) {
    clearTimeout(redirectTimeoutId)
    redirectTimeoutId = null
  }
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/wizard-steps';
@import '~@/assets/styles/onboarding-ai-step';

.oai-FailedStep {
  @extend %wizard-step-styles;

  --step-max-width: 480px;
  --step-gap: 24px;
  width: 100%;
  max-width: var(--step-max-width);
  margin-inline: auto;
}

.oai-FailedStep_Header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.oai-FailedStep_LogoContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: $border-radius-md;
  background: $white;
}

.oai-FailedStep_Title {
  color: $oai-text-primary;
  font-size: 36px;
  font-weight: fw('bold');
  line-height: 44px;
  letter-spacing: -0.72px;
}

.oai-FailedStep_Subtitle {
  font-size: $fs-14;
  line-height: 20px;
  color: $oai-text-muted;
}
</style>
